import { render, staticRenderFns } from "./CardNoData.vue?vue&type=template&id=ea38f556"
import script from "./CardNoData.vue?vue&type=script&lang=js"
export * from "./CardNoData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports